import client from '../../../services/session/apiClient';
import SessionStore from "../../../services/session/SessionStore";

// TODO - there's another file with very related apis. Should be merged

export const publish = async (payload = {}) => {
  try {
    const response = await client.post(
      '/chatter/publishing/posts',
      {
        ...payload,
        userId: SessionStore.user.userId,
        accountId: SessionStore.account.accountId,
        billingAccountId: SessionStore.account.billingAccountId
      }
    );
    return response.data.post;
  } catch (e) {
    // Why do we throw different errors/strings for the same error? Facebook Reply fails vs Twitter Like fails, for example.
    const SECEXC = "No credentials in your account have permission to publish to page.";
    const CANNOTRETWEET = "Your user account is missing permissions to retweet a post.";
    const CANNOTLIKE = "Your user account is missing permissions to like a post.";

    let errorMsg = "We were not able to publish your post.";
    if (e.response.data && e.response.data.exception) errorMsg = e.response.data.exception;
    if (e.response.data && e.response.data.error) errorMsg = e.response.data.error;

    // More user-friendly and standardized error messages
    if (errorMsg.includes(SECEXC)) {
      throw new Error(SECEXC);
    } else if (errorMsg.includes(CANNOTRETWEET)) {
      throw new Error(CANNOTRETWEET);
    } else if (errorMsg.includes(CANNOTLIKE)) {
      throw new Error(CANNOTLIKE);
    } else {
      throw e;
    }
  }
};

export function retryPost({postId, remoteId}) {
  return client.post(`/chatter/publishing/posts/${encodeURIComponent(postId)}/retry`, {}, {params: {remoteId}});
}

/**
 *
 * @param {Date} start?
 * @param {Date} end?
 * @param {string} groupId?
 * @param {string} accountId?
 * @param {string} provider?
 * @returns {Promise<PostToBePublished[]>>}
 */
export function listPosts({
 start, end, groupId, accountId, provider
}) {
  return client.post('/chatter/publishing/posts/list', {
    end: end && end.getTime(),
    start: start && start.getTime(),
    groupId,
    accountId,
    provider
  }).then(response => {
    return response.data.posts;
  })
}


export function loadPost(postId) {
  return client.get(`/chatter/publishing/posts/${postId}`).then(resp => resp.data.post);
}

/**
 *
 * @param {Post} post
 * @return {Promise.<{post: Object.<PostMessage>}>}
 */

export function updatePost(postId, post) {
  console.warn("should make post replies and publish post have the same id structure, the former is _.id.$oid and the latter is _id");
  return client.put(`/chatter/publishing/posts/${postId}`, post).then(resp => resp.data.post);
}

export function getDeliveryLogs(postId) {
 return client.get(`/chatter/publishing/posts/${encodeURIComponent(postId)}/logs`).then(response => response.data.logs);
}

/**
 *
 * @param {string} postId
 * @param {string} rejectedReason
 * @returns {Promise.<PostToBePublished>}
 */
export function rejectPost(postId, rejectedReason){
  return client.post(`/chatter/publishing/posts/${encodeURIComponent(postId)}/reject`, { rejectedReason }).then(response => response.data);
}
/**
 *
 * @param {string} postId
 * @returns {Promise.<PostToBePublished>}
 */
export function approvePost(postId, post) {
  return client.post(`/chatter/publishing/posts/${encodeURIComponent(postId)}/approve`, post).then(response => response.data);
}

export async function pagesById(provider, remoteIds) {
  var i,j,chunkOfIds,chunk = 90;
  let accumulator=[]
  //Break it into chunks so we don't make the URI too long
  for (i=0,j=remoteIds.length; i<j; i+=chunk) {
    chunkOfIds = remoteIds.slice(i,i+chunk);
    await client.get(`/chatter/publishing/pages/${provider}`, {params: {remoteIds: chunkOfIds.join(",")}}).then(response => accumulator.push(...response.data.pages))
  }
  return accumulator
}

export function listGroups(provider, searchText) {
  return client.get(`/chatter/settings/listingGroups`, {params: {provider, searchText}}).then(response => response.data);
}


